//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableFeedBuilder.js";
let d=[[[1,"FeedApproachBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedCutBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedDepartureBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedEngageBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedFirstCutBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedRapidBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedRetractBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedReturnBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedSideCutBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedStepoverBuilder",0,"CAM.InheritableFeedBuilder",0],[1,"FeedTraversalBuilder",0,"CAM.InheritableFeedBuilder",0],[0,"OutputMode",1,0],[0,"UnitsToggle",1,0]],[],[]];
SPLM.CAM.FeedsWedmBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeedsWedmBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeedsWedmBuilder.OutputTypes = Object.freeze({
    "None" : "None", "RapidMovesOnly" : "RapidMovesOnly", "AllMoves" : "AllMoves"});

export default SPLM;